import { render } from "./FileViewer.vue?vue&type=template&id=b9e75c58&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"

import "./FileViewer.vue?vue&type=style&index=0&id=b9e75c58&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e75c58"]])

export default __exports__